export default __webpack_public_path__ + "static/media/variety.b02d79c6.png";